export default __webpack_public_path__ + "static/media/Member_ShiangChiHuang.2f49214f.jpg";